import React, { Component } from "react";
import { SIDE_NAV_ITEMS } from "../../../api-constant";
import Sidebar from "../../Sidebar/sidebar";
import ResponsiveSidebar from "../../Sidebar/Responsive/SideBar";
import NavBar from "../../NavBar/Navbar";

import { withRouter } from "react-router";
import AssessmentsReport from "./Asssessment-Report";


const calcWidth = window.innerWidth;
export class AssessmentReports extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedSideNav: SIDE_NAV_ITEMS[1].id,
      sidebarOpen: false,
      enableNotification: false,
      assessmentDetails: null,
      userId: "",
      downloadReportDropdown: [],
      devPlan: null,
      devPlanList: [],
      checkMultiRater: null,
      dataloader: null,
      collapseID: null,
    };
  }
  handleNotification = () => {
    this.setState({
      enableNotification: !this.state.enableNotification,
    });
  };
  /* handle api calls */
  componentDidMount() {
    const id = this.props.match.params.id;
    const participant__id = this.props.match.params.participant__id;



  }

  onSetSidebarOpen = (open) => {
    this.setState({
      sidebarOpen: open,
    });
  };




  toggleCollapse = (collapseID) => {
    if (this.state.collapseID === collapseID) {
      this.setState({
        collapseID: null,
      });
    } else {
      this.setState({
        collapseID: collapseID,
      });
    }
  };

  render() {
    return (
      <div>
        <NavBar
          enableNotification={this.state.enableNotification}
          handleNotification={this.handleNotification}
        />
        <ResponsiveSidebar
          items={SIDE_NAV_ITEMS}
          selectedSideNav={this.state.selectedSideNav}
          sidebarOpen={this.state.sidebarOpen}
          onSetSidebarOpen={this.onSetSidebarOpen}
        />
        <Sidebar
          items={SIDE_NAV_ITEMS}
          selectedSideNav={this.state.selectedSideNav}
        />
        <AssessmentsReport/>

      </div>
    );
  }
}

export default withRouter(AssessmentReports);



// WEBPACK FOOTER //
// ./src/new/Components/Reports/Assessment-Reports/index.jsx